import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EnrollIntroduction.scss';
import timerIcon from './timer_icon.png';
import wynIcon from './wyn_icon.png';
import Logout from '../../../shared/Logout/Logout';
import imprivataIcon from '../../Login/Icons/imprivata.svg';

/**
 * Enrollment Introduction control
 * @class EnrollIntroduction
 * @extends {Component}
 */
class EnrollIntroduction extends Component {
  static propTypes = {
    /** The header text for this enrollment screen */
    headerTitle: PropTypes.string,
    /** The amount of time to enroll this modality */
    setupTime: PropTypes.string,
    /** The requirements for enrolling this modality */
    setupRequirements: PropTypes.string,
    /** Determines if the user can skip the enrollment process - shows the 'Do this later' link */
    canSkipEnrollment: PropTypes.bool,
    /** Function executed when 'Do this later' is clicked */
    onSkipEnroll: PropTypes.func,
    /** If present, a link appears with this text that allows the user to enroll a different method. */
    canEnrollAlternativeText: PropTypes.string,
    /** Function executed when 'Enroll another method' is clicked */
    onEnrollAnother: PropTypes.func,
    /** Text displayed on the submit button */
    submitText: PropTypes.string,
    /** Function executed when submit button is clicked */
    onSubmitClicked: PropTypes.func,
    /** The timer image */
    timerImage: PropTypes.string,
    /** The wyn image */
    wynImage: PropTypes.string,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
  };
  static defaultProps = {
    headerTitle: 'Imprivata ID',
    setupTime: '2 minutes',
    setupRequirements: 'Your smartphone',
    canSkipEnrollment: false,
    canEnrollAlternativeText: null,
    submitText: 'Enroll Imprivata ID',
    timerImage: timerIcon,
    wynImage: wynIcon,
    logoutComponent: <Logout/>,
  };
  render() {
    return (
      <div className='CIDRA'>
        {this.props.logoutComponent}
        <div className='login-container'>
          <div className='form-group login-header'>
            {
              this.props.headerTitle ? (
                <h2 id='EnrollIntroduction_header_title' className='header-title'>
                  {this.props.headerTitle}
                </h2>
              ) : null
            }
          </div>
          <div className='form-group'>
            <div className='enroll-description'>
              {this.props.children}
            </div>
            <br/>
            <div id='EnrollIntroduction_setuptime' className='header-description testing'>
              <div className='enroll-img-container timer'>
                <img src={this.props.timerImage} alt=''/>
              </div>
              <div>
                <strong>Setup time:</strong>
              </div>
              <div>
                {this.props.setupTime}
              </div>
            </div>
            <div id='EnrollIntroduction_whatyouneed' className='header-description testing'>
              <div className='enroll-img-container wyn'>
                <img src={this.props.wynImage} alt=''/>
              </div>
              <div>
                <strong>What you need:</strong>
              </div>
              <div>
                {this.props.setupRequirements}
              </div>
            </div>
          </div>
          <br/>
          <div className='form-group CIDRA-Field'>
            <button
              id='EnrollIntroduction_submit_button'
              className='btn btn-primary btn-block'
              onClick={this.props.onSubmitClicked}>
              {this.props.submitText}
            </button>
          </div>
          <br/>
          <div className='text-center'>
            {
              this.props.canEnrollAlternativeText ? (
                // eslint-disable-next-line
                <a id='EnrollIntroduction_link_EnrollAnother' className='btn btn-link' onClick={this.props.onEnrollAnother}>
                  { this.props.canEnrollAlternativeText }
                </a>
              ) : null
            }
            <br/>
            {
              this.props.linkText ? (
                // eslint-disable-next-line
                <a id='EnrollIntroduction_link_DoThisLater' className='btn btn-link' onClick={this.props.onSkipEnroll}>
                  {this.props.linkText}
                </a>
              ) : null
            }
          </div>
        </div>
        { this.props.footer }
        <hr className='Footer-hr'/>
        <img className='Footer' src={imprivataIcon} alt='logo'/>
      </div>
    );
  }
}

export default EnrollIntroduction;
